import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import CustomTextField from "../../common/CustomTextField";
import { useForm } from "react-hook-form";
import { SaveAlt, Search } from "@mui/icons-material";
import CustomAlert from "../../common/CustomAlert";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import { CodeTable, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import { FieldLabel, sortNames } from "../../../utils/Utility";
import CustomMultipleDropDown from "../../common/CustomMultipleDropDown";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { getWoundCodeValuesByWoundCodeType, fetchAllWoundCodes, useWoundCodesSlice, WoundCodes, fetchAllWoundCodesByQuery, fetchWoundInfoByWoundCodes } from "../../../redux/slice/ivr/woundCodeSlice"
import BorderedSection from "../../common/BorderedSection";
import CustomNumberField from "../../common/CustomNumberField";
import CustomCheckbox from "../../common/CustomCheckBox";
import { setSingleAlertObj, SingleAlertInfo } from "../../../redux/slice/commonSlice";
import { CAN_ACCESS_APPLICATION } from "../../../constants/applicationConstants";
import CustomAutocompleteField from "../../common/CustomAutocompleteField";
import IVRWoundSearchPopup from "./IVRWoundSearchPopup";
import { useModalStyles } from "../../common/useModalStyles";
import { Bandage } from "lucide-react";

interface WoundInfoProps {
  open: boolean;
  onClose: () => void;
  onAddWoundInfo: (woundData: any) => void;
  currentWoundInfo?: any;
  from?: string;
  ivrId?: number;
}

export const woundInfoInitialState: any = {
  woundType: "",
  // noOfApplications: "",
  cpt: "",
  eCode: "",
  iCode: "",
  lCode: "",
  otherDxCodes: "",
  length: "",
  width: "",
  depth: "",
  totalSize: "",
  estimateSurfaceArea: "",
  totalWoundVolume: "",
  procedureLocation:''
};

//CS-1192 - Start
const woundTypesOptions = [
  { value: "Acute Wound", label: "Acute Wound" },
  { value: "Chronic Wound", label: "Chronic Wound" },
  { value: "Diabetic Ulcer", label: "Diabetic Ulcer" },
  { value: "Pressure Ulcer", label: "Pressure Ulcer" },
  { value: "Venous Ulcer", label: "Venous Ulcer" },
  { value: "Other", label: "Other" },
];
//CS-1192 - End

const noOfAppOptions: { value: string | number; label: string }[] = [
  { value: "1-3", label: "1 - 3" },
  { value: "4-6", label: "4 - 6" },
  { value: "7-10", label: "7 - 10" },
];

const IVRFormWoundInfoPopup: React.FC<WoundInfoProps> = ({
  open,
  onClose,
  onAddWoundInfo,
  currentWoundInfo,
  from,
  ivrId
}) => {
  const { control, handleSubmit, reset, setValue, getValues, watch, clearErrors, trigger, formState: { errors } } = useForm({
    defaultValues: woundInfoInitialState,
  });
  const dispatch = useAppDispatch();
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const length = watch("length");
  const width = watch("width");
  const depth = watch("depth");
  const woundType = watch("woundType");
  const { allCodeTablesValuesMap, allCodeTableValueFetchStatus } =
    useCodetablesSlice();
  const { allWoundCodesValuesMap, woundCodeFetchStatus } = useWoundCodesSlice();
  const [cptOptions, setCptOptions] = useState<
    { value: string | number; label: string }[]
  >([]);
  const [iCodeOptions, setICodeOptions] = useState<
    { value: string | number; label: string }[]
  >([]);
  const [lCodeOptions, setLCodeOptions] = useState<
  { value: string | number; label: string; location:string|any }[]
  >([]);
  const [procedureLocationOptions, setProcedureLocationOptions] = useState<
    { value: string | number; label: string }[]
  >([]);
  const [eCodeOptions, setECodeOptions] = useState<
    { value: string | number; label: string }[]
  >([]);
  const [selectedCPTs, SetSelectedCPTs] = useState<WoundCodes[] | null>(null);
  const [specifyOtherDxCodes, setSpecifyOtherDxCodes] = useState(false);
  const [shouldShowDxCodesField, setShouldShowDxCodesField] = useState(false);

  const [selectedCptOptions, setSelectedCptOptions] = useState<any[]>([]);
  const [selectedLcodeOptions, setSelectedLcodeOptions] = useState<any[]>([]);
  const [selectedecodeOptions, setSelectedecodeOptions] = useState<any[]>([]);
  const [selectedicodeOptions, setSelectedicodeOptions] = useState<any[]>([]);
  const [selectedIcdcodeOptions, setSelectedIcdcodeOptions] = useState<any[]>([]);
  const [exudateLevelList, setExudateLevelList] = useState<CodeTable[]>([]); 
  const [ showSearchPopup, setShowSearchPopup] = useState<boolean>(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    tokens: modalTokens,
    paperSx,
    headerSx,
    iconBoxSx,
    bodySx,
    footerSx,
    closeIconSx,
    dropdownWrapSx,
    dropdownWrapWithLabelSx,
    inputFieldSx,
    primaryBtnSx,
    cancelBtnSx,
  } = useModalStyles();

  // React.useEffect(() => {
  //   if (allCodeTableValueFetchStatus === "success" && allCodeTablesValuesMap) {
  //     setCptOptions(
  //       getCodeTableValuesByTableName(
  //         allCodeTablesValuesMap,
  //         "WoundInfo_CPTCode"
  //       ).map((item) => ({
  //         value: item.keyName,
  //         label: item.displayValue,
  //       }))
  //     );
  //     setICodeOptions(
  //       getCodeTableValuesByTableName(
  //         allCodeTablesValuesMap,
  //         "WoundInfo_ICode"
  //       ).map((item) => ({
  //         value: item.keyName,
  //         label: item.displayValue,
  //       }))
  //     );

  //     const woundInfoLCode = getCodeTableValuesByTableName(allCodeTablesValuesMap, "WoundInfo_LCode")
  //     const sortedLCodeData = woundInfoLCode ? sortNames(woundInfoLCode, 'keyName') : [];
  //     setLCodeOptions(
  //       sortedLCodeData.map((item: any) => ({
  //         value: item.keyName,
  //         label: item.displayValue,
  //       }))
  //     );

  //     setECodeOptions(
  //       getCodeTableValuesByTableName(
  //         allCodeTablesValuesMap,
  //         "WoundInfo_ECode"
  //       ).map((item) => ({
  //         value: item.keyName,
  //         label: item.displayValue,
  //       }))
  //     );
  //   }
  // }, [allCodeTablesValuesMap, allCodeTableValueFetchStatus]);

  React.useEffect(() => {
    if (open) {
      dispatch(fetchAllWoundCodes());
    }
  }, [open, dispatch]);

  React.useEffect(() => {
    if (woundCodeFetchStatus === "success" && allWoundCodesValuesMap) {

      const cptCodes = getWoundCodeValuesByWoundCodeType(allWoundCodesValuesMap, "CPTCODE")
      const sortedCPTCodes = cptCodes ? sortNames(cptCodes, 'woundKey') : [];
      setCptOptions(
        sortedCPTCodes.map((item: any) => ({
          value: item.woundKey,
          label: item.woundDisplayValue,
        }))
      );

      const eCodes = getWoundCodeValuesByWoundCodeType(allWoundCodesValuesMap, "ECODE")
      const sortedECodes = eCodes ? sortNames(eCodes, 'woundKey') : [];
      setECodeOptions(
        sortedECodes.map((item: any) => ({
          value: item.woundKey,
          label: item.woundDisplayValue,
        }))
      );

      const iCodes = getWoundCodeValuesByWoundCodeType(allWoundCodesValuesMap, "ICODE")
      const sortedICodes = iCodes ? sortNames(iCodes, 'woundKey') : [];
      setICodeOptions(
        sortedICodes.map((item: any) => ({
          value: item.woundKey,
          label: item.woundDisplayValue,
        }))
      );

      const lCodes = getWoundCodeValuesByWoundCodeType(allWoundCodesValuesMap, "LCODE")
      const sortedLCodes = lCodes ? sortNames(lCodes, 'woundKey') : [];
      setLCodeOptions(
        sortedLCodes.map((item: any) => ({
          value:item.woundKey,
          label: item.woundDisplayValue,
          location:item.woundLocation          
        }))
      );
      const procedureLocation = getWoundCodeValuesByWoundCodeType(allWoundCodesValuesMap, "ProcedureLocation")
      setProcedureLocationOptions(
        procedureLocation.map((item: any) => ({
          value: item,
          label: item,
        }))
      );
    }
  }, [woundCodeFetchStatus, allWoundCodesValuesMap]);
  useEffect(()=>{
    setValue("procedureLocation","unspecified")
  },[watch("woundType")==="Other"])

  useEffect(() => {
    if (open && !currentWoundInfo) {
      reset(woundInfoInitialState);
    } else if (currentWoundInfo) {
      Object.keys(currentWoundInfo).forEach((key) => {
        if (key === 'cpt' && typeof currentWoundInfo[key] === 'string' && currentWoundInfo[key].trim() !== "") {
          const cptCodes = currentWoundInfo[key]?.split(",").map((code: string) => code.trim());
          setValue(key, cptCodes, {
            shouldValidate: true,
          });
        } else if (key === 'eCode' && typeof currentWoundInfo[key] === 'string' && currentWoundInfo[key].trim() !== "") {
          const eCodes = currentWoundInfo[key]?.split(",").map((code: string) => code.trim());
          setValue(key, eCodes, {
            shouldValidate: true,
          });
        } else if (key === 'iCode' && typeof currentWoundInfo[key] === 'string' && currentWoundInfo[key].trim() !== "") {
          const iCodes = currentWoundInfo[key]?.split(",").map((code: string) => code.trim());
          setValue(key, iCodes, {
            shouldValidate: true,
          });
        } else if (key === 'lCode' && typeof currentWoundInfo[key] === 'string' && currentWoundInfo[key].trim() !== "") {
          const lCodes = currentWoundInfo[key]?.split(",").map((code: string) => code.trim());
          setValue(key, lCodes, {
            shouldValidate: true,
          });
        } else if (key === 'icd10' && typeof currentWoundInfo[key] === 'string' && currentWoundInfo[key].trim() !== "") {
          const icd10 = currentWoundInfo[key]?.split(",").map((code: string) => code.trim());
          setValue(key, icd10, {
            shouldValidate: true,
          })
        } else if (key === 'exudate' && typeof currentWoundInfo[key] === 'object') {
          setValue(key, currentWoundInfo[key]?.props?.children, {
            shouldValidate: true,
          });
        } else {
          setValue(key, currentWoundInfo[key], {
            shouldValidate: true,
          });
        }
      });
    }
  }, [open, currentWoundInfo]);

  React.useEffect(() => {
    const lengthValue = parseFloat(length);
    const widthValue = parseFloat(width);
    const depthValue = parseFloat(depth);

    if (!isNaN(lengthValue) && !isNaN(widthValue) && lengthValue > 0 && widthValue > 0) {
      const surfaceArea = (lengthValue * widthValue).toFixed(2);
      setValue("estimateSurfaceArea", `${surfaceArea}cm²`, { shouldValidate: true });
      // Keep totalSize in sync for API / parent consumers (L x W)
      setValue("totalSize", surfaceArea, { shouldValidate: true });
      if (!isNaN(depthValue) && depthValue >= 0) {
        const volume = (lengthValue * widthValue * depthValue).toFixed(2);
        setValue("totalWoundVolume", `${volume}cm³`, { shouldValidate: true });
      } else {
        setValue("totalWoundVolume", "", { shouldValidate: true });
      }
    } else {
      setValue("estimateSurfaceArea", "", { shouldValidate: true });
      setValue("totalWoundVolume", "", { shouldValidate: true });
      setValue("totalSize", "", { shouldValidate: true });
    }
  }, [length, width, depth, setValue, woundType]);

  const onSubmit = (data: any) => {
    const formattedData = {
      ...data,
      cpt: data.cpt,
    };
    onAddWoundInfo(formattedData);
    // setShowErrorAlert(true);
    reset(woundInfoInitialState);
    onClose();

    let errorObj: SingleAlertInfo = {
      message: `Wound data has been successfully added to the ${ivrId ? "patient profile and this IVR form." : from === CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT ? "Patient." : `IVR Form.`}`,
      alertType: "success"
    };
    dispatch(setSingleAlertObj(errorObj));
  };

  const onError = (_errors: any, e: any) => {

    const checked = specifyOtherDxCodes;
    let hasError = false;

    if (checked) {
      hasError = false;
      clearErrors("eCode");
      clearErrors("iCode");
      clearErrors("lCode");
    } else {
      hasError = true;
      trigger("eCode");
      trigger("iCode");
      trigger("lCode");
    };

    if (!(Object.keys(errors).length > 0 || hasError)) {
      const data = getValues();
      onSubmit(data);
    };
  };

  const selectedCptValues = watch('cpt');
  const selectedECodeValues = watch('eCode');
  const selectedLCodeValues = watch('lCode');
  const selectedICodeValues = watch('iCode');

  const resolveSelectedWoundCodes = (selectedKeys: any[], woundCodeType: string) => {
    if (!allWoundCodesValuesMap || !Array.isArray(selectedKeys) || selectedKeys.length === 0) {
      return [];
    }
    const codes = getWoundCodeValuesByWoundCodeType(allWoundCodesValuesMap, woundCodeType) || [];
    return codes.filter((code: any) => selectedKeys.includes(code.woundKey));
  };

  useEffect(() => {
    if (!Array.isArray(selectedCptValues) || selectedCptValues.length === 0) {
      setSelectedCptOptions([]);
      return;
    }
    setSelectedCptOptions(resolveSelectedWoundCodes(selectedCptValues, "CPTCODE"));
  }, [selectedCptValues, allWoundCodesValuesMap]);

  useEffect(() => {
    if (!Array.isArray(selectedECodeValues) || selectedECodeValues.length === 0) {
      setSelectedecodeOptions([]);
      return;
    }
    setSelectedecodeOptions(resolveSelectedWoundCodes(selectedECodeValues, "ECODE"));
  }, [selectedECodeValues, allWoundCodesValuesMap]);

  useEffect(() => {
    if (!Array.isArray(selectedLCodeValues) || selectedLCodeValues.length === 0) {
      setSelectedLcodeOptions([]);
      return;
    }
    setSelectedLcodeOptions(resolveSelectedWoundCodes(selectedLCodeValues, "LCODE"));
  }, [selectedLCodeValues, allWoundCodesValuesMap]);

  useEffect(() => {
    if (!Array.isArray(selectedICodeValues) || selectedICodeValues.length === 0) {
      setSelectedicodeOptions([]);
      return;
    }
    setSelectedicodeOptions(resolveSelectedWoundCodes(selectedICodeValues, "ICODE"));
  }, [selectedICodeValues, allWoundCodesValuesMap]);

  useEffect(() => {
    setValue(
      'cptIds',
      (selectedCptOptions || [])
        .filter((opt): opt is { woundcodeId: any } => !!opt && opt.woundcodeId !== undefined && opt.woundcodeId !== null)
        .map(opt => opt.woundcodeId)
    );
    SetSelectedCPTs(selectedCptOptions?.length ? selectedCptOptions : null);
  }, [selectedCptOptions]);

  useEffect(() => {
    if (!selectedLcodeOptions || selectedLcodeOptions.length === 0) return;
    if(selectedLcodeOptions?.length > 0){
      setValue('procedureLocation',selectedLcodeOptions[0]?.woundLocation)
    }
    setValue(
      'lCodeIds',
      selectedLcodeOptions
        .filter((opt): opt is { woundcodeId: any } => !!opt && opt.woundcodeId !== undefined && opt.woundcodeId !== null)
        .map(opt => opt.woundcodeId)
    );
  
  }, [selectedLcodeOptions]);

  useEffect(() => {
    if (!selectedecodeOptions || selectedecodeOptions.length === 0) return;
    setValue(
      'eCodeIds',
      selectedecodeOptions
        .filter((opt): opt is { woundcodeId: any } => !!opt && opt.woundcodeId !== undefined && opt.woundcodeId !== null)
        .map(opt => opt.woundcodeId)
    );
  
  }, [selectedecodeOptions]);


  useEffect(() => {
    if (!selectedicodeOptions || selectedicodeOptions.length === 0) return;
    setValue(
      'iCodeIds',
      selectedicodeOptions
        .filter((opt): opt is { woundcodeId: any } => !!opt && opt.woundcodeId !== undefined && opt.woundcodeId !== null)
        .map(opt => opt.woundcodeId)
    );
  
  }, [selectedicodeOptions]);

  useEffect(() => {
    if (!selectedIcdcodeOptions || selectedIcdcodeOptions.length === 0) return;
    setValue(
      'icdIds',
      selectedIcdcodeOptions
        .filter((opt): opt is { woundcodeId: any } => !!opt && opt.woundcodeId !== undefined && opt.woundcodeId !== null)
        .map(opt => opt.woundcodeId)
    );
  
  }, [selectedIcdcodeOptions]); 
  

  const eCodeDropdown = () => {
    return (
      <>
        <Grid item xs={12}>
          <Box>
            <FieldLabel label="E Code" required={!specifyOtherDxCodes} tokens={modalTokens} />
            <Box sx={dropdownWrapSx(!!errors.eCode)}>
              <CustomMultipleDropDown
                name="eCode"
                control={control}
                label=""
                size="small"
                options={eCodeOptions}
                rules={specifyOtherDxCodes ? undefined : { required: "E Code is required." }}
                onChangeSelect={(_e, value) => {
                  setSelectedecodeOptions(resolveSelectedWoundCodes(Array.isArray(value) ? value : [], "ECODE"));
                }}
              />
            </Box>
          </Box>
        </Grid>
      </>
    )
  };

  const lCodeDropdown = () => {
    return (
      <>
        <Grid item xs={12}>
          <Box>
            <FieldLabel label="L Code" required tokens={modalTokens} />
            <Box sx={dropdownWrapSx(!!errors.lCode)}>
              <CustomMultipleDropDown
                name="lCode"
                control={control}
                label=""
                size="small"
                options={lCodeOptions}
                rules={{ required: "L Code is required." }}
                onChangeSelect={(_e, value) => {
                  setSelectedLcodeOptions(resolveSelectedWoundCodes(Array.isArray(value) ? value : [], "LCODE"));
                }}
              />
            </Box>
          </Box>
        </Grid>
      </>
    )
  };
  const iCodeDropdown = () => {
    return (
      <>
        <Grid item xs={12}>
          <Box>
            <FieldLabel label="I Code" required={!specifyOtherDxCodes} tokens={modalTokens} />
            <Box sx={dropdownWrapSx(!!errors.iCode)}>
              <CustomMultipleDropDown
                name="iCode"
                control={control}
                label=""
                size="small"
                options={iCodeOptions}
                rules={specifyOtherDxCodes ? undefined : { required: "I Code is required." }}
                onChangeSelect={(_e, value) => {
                  setSelectedicodeOptions(resolveSelectedWoundCodes(Array.isArray(value) ? value : [], "ICODE"));
                }}
              />
            </Box>
          </Box>
        </Grid>
      </>
    )
  };

  const handleCheckboxChange = (event: { target: { checked: any; }; }) => {
    const checked = event.target.checked;

    setSpecifyOtherDxCodes(checked);
    setValue("checkboxSpecifiedDxCodes", checked);
    if (getValues("otherDxCodes") !== "") {
      setSpecifyOtherDxCodes(true);
    }
    setShouldShowDxCodesField(checked || getValues("otherDxCodes") !== "");
  };

  useEffect(() => {
    const otherDxCodesValue = getValues("otherDxCodes");

    if (otherDxCodesValue === "") {
      setSpecifyOtherDxCodes(false);
      setValue("checkboxSpecifiedDxCodes", false);
      setShouldShowDxCodesField(false);
    }
    else if (otherDxCodesValue !== "") {
      setShouldShowDxCodesField(true);
      setSpecifyOtherDxCodes(true);
    }
  }, [watch("otherDxCodes")]);

  useEffect(() => {
    if (woundType === "Diabetic Ulcer" && (currentWoundInfo?.iCode !== "")) {
      setValue("iCode", []);
    } else if (woundType === "Venous Ulcer" && currentWoundInfo?.eCode !== "") {
      setValue("eCode", []);
    } else if ((woundType === "Pressure Ulcer" || woundType === "Chronic Wound") && (currentWoundInfo?.iCode !== "" || currentWoundInfo?.eCode !== "")) {
      setValue("eCode", []);
      setValue("iCode", []);
    }
  }, [woundType, setValue, currentWoundInfo]);

  const fetchWoundCodesByWoundKey = async (query: string, type?: string) => {
    //CS-1192 - Start
    if (query.length < 2 && type === "ICD10") {
      return []; // Don't call API if less than 2 characters
    }
    //CS-1192 - End
    try {
      const woundCodeType = type ?? '';
      const response = await dispatch(fetchAllWoundCodesByQuery({searchQuery: query, woundType: woundCodeType, skipLoader: true})).unwrap();
      return response;
    } catch (err) {
      console.error("Failed to fetch wound codes:", err);
      return [];
    }
  };

  const fetchWoundsByWoundCodes = async (code: string, type?: string) => {
    try {
      const woundCodeType = type ?? '';
      const response = await dispatch(fetchWoundInfoByWoundCodes({key: code, woundType: woundCodeType})).unwrap();
      return response;
    } catch (err) {
      console.error("Failed to fetch wound codes:", err);
      return [];
    }
  };

  const transformWoundCodeResponse = (res: any, woundCodeType?: string): any[] => {
    if (woundCodeType === "ICD10") {
      return (res?.data?.ICD10 || []).map((item: any) => ({
        value: item.woundKey,
        label: `${item.woundKey} - ${item.woundDisplayValue}`,
      }));
    } else if (woundCodeType === "CPTCODE") {
      return (res?.data?.CPTCODE || []).map((item: any) => ({
        value: item.woundKey,
        label: `${item.woundDisplayValue}`,
      }));
    } else if (woundCodeType === "ECODE") {
      return (res?.data?.ECODE || []).map((item: any) => ({
        value: item.woundKey,
        label: `${item.woundDisplayValue}`,
      }));
    } else if (woundCodeType === "LCODE") {
      return (res?.data?.LCODE || []).map((item: any) => ({
        value: item.woundKey,
        label: `${item.woundDisplayValue}`,
      }));
    } else if (woundCodeType === "ICODE") {
      return (res?.data?.ICODE || []).map((item: any) => ({
        value: item.woundKey,
        label: `${item.woundDisplayValue}`,
      }));
    } else if (woundCodeType === "ProcedureLocation") {
      //CS-1192 - Start
      return (res?.data?.ProcedureLocation || []).map((item: string) => ({
        value: item.split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' '),
        label:item
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' '),
      }));
      //CS-1192 - End
    }
    return [];
  };
  

  const handleChangeWoundType = (e: any, value: any) => {
    reset({
      woundType: value,
      noOfApplications: '',
      cpt: '',
      lcode: '',
      icode: '',
      icd10: '',
      ecode: '',
      procedureLocation: '',
      checkboxSpecifiedDxCodes: '',
      otherDxCodes: '',
      length: '',
      width: '',
      depth: '',
      totalSize: '',
      estimateSurfaceArea: '',
      totalWoundVolume: ''
    });
    setSelectedCptOptions([])
    SetSelectedCPTs([]);
  }
  useEffect(() => {
    if (allCodeTableValueFetchStatus === "success" && allCodeTablesValuesMap) {
      setExudateLevelList(
        getCodeTableValuesByTableName(allCodeTablesValuesMap, "ExudateLevel")
      );
    }
  }, [allCodeTablesValuesMap, allCodeTableValueFetchStatus]);

  const exudateListOptions = useMemo(() => {
    return exudateLevelList.map(item => ({
      label: item.displayValue,
      value: item.keyName
    }));
  }, [exudateLevelList]);

  const headerTitle = currentWoundInfo?.woundInfoKey
    ? `${currentWoundInfo?.woundInfoKey} Information`
    : "Add Wound Information";

  const showIcdSearchInHeader =
    (shouldShowDxCodesField) || woundType === "Other" || woundType === "Acute Wound";

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        fullScreen={isMobile}
        scroll="paper"
        onClick={(event) => {
          event.stopPropagation();
        }}
        PaperProps={{ sx: paperSx(isMobile) }}
      >
        <Box sx={headerSx}>
          <Box sx={iconBoxSx(modalTokens.accent)}>
            <Bandage size={22} color={modalTokens.accent} strokeWidth={1.8} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: 1.5,
              }}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  fontWeight={700}
                  sx={{
                    fontSize: "1.1rem",
                    color: modalTokens.textPrimary,
                    lineHeight: 1.3,
                  }}
                >
                  {headerTitle}
                </Typography>
                <Typography sx={{ fontSize: "0.8rem", color: modalTokens.textSecondary, mt: 0.15 }}>
                  Enter wound type, codes, and measurements
                </Typography>
              </Box>
              {showIcdSearchInHeader && (
                <Tooltip title="Search for ICD-10 Codes">
                  <IconButton
                    size="small"
                    onClick={() => setShowSearchPopup(true)}
                    sx={{
                      flexShrink: 0,
                      border: `1px solid ${modalTokens.border}`,
                      borderRadius: "10px",
                      color: modalTokens.accent,
                      "&:hover": {
                        borderColor: modalTokens.accent,
                        backgroundColor: "rgba(20,184,166,0.08)",
                      },
                    }}
                  >
                    <Search fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Box>
          <IconButton onClick={handleClose} size="small" sx={closeIconSx}>
            <CloseIcon sx={{ fontSize: "1rem" }} />
          </IconButton>
        </Box>

        <Box
          component="form"
          onSubmit={handleSubmit(onSubmit, onError)}
          sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden" }}
        >
          <Box
            sx={{
              ...bodySx,
              gap: 1.5,
              py: 2,
              minHeight: 0,
              "&::-webkit-scrollbar": { width: 6, height: 6 },
              "&::-webkit-scrollbar-track": { background: "transparent" },
              "&::-webkit-scrollbar-thumb": {
                background: theme.palette.mode === "dark" ? "rgba(255,255,255,0.12)" : "#CBD5E1",
                borderRadius: 4,
              },
            }}
          >
              <Grid container spacing={1.5}>
                <Grid item xs={12} md={6}>
                  <Box>
                    <FieldLabel label="Type" required tokens={modalTokens} />
                    <Box sx={dropdownWrapSx(!!errors.woundType)}>
                      <CustomDropdownField
                        name="woundType"
                        control={control}
                        options={woundTypesOptions}
                        label=""
                        size="small"
                        onChangeSelect={handleChangeWoundType}
                        sortOptions={false}
                        rules={{ required: "Type is required." }}
                        onBlur={(event) => {
                          const typedValue = event.target.value;
                          const isValidOption = woundTypesOptions.some(
                            option => option.value === typedValue || option.label === typedValue
                          );

                          if (!isValidOption && typedValue) {
                            setValue('woundType', '');
                          }
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
               {/* CS-1187 - Start  */}
                {/* <Grid item xs={12} md={6}>
                  <CustomDropdownField
                    name="noOfApplications"
                    control={control}
                    options={noOfAppOptions}
                    label="# of Applications"
                    rules={{ required: "No of application is required." }}
                  />
                </Grid> */}
                {/* CS-1187 - End */}

                {!(woundType === "Acute Wound") && (
                  <Grid item xs={12}>
                      <Box>
                        <FieldLabel label="CPT Code" required tokens={modalTokens} />
                        <Box sx={dropdownWrapSx(!!errors.cpt)}>
                          <CustomMultipleDropDown
                            name="cpt"
                            control={control}
                            label=""
                            size="small"
                            options={cptOptions}
                            rules={{ required: "CPT Code is required." }}
                            onChangeSelect={(_e, value) => {
                              setSelectedCptOptions(resolveSelectedWoundCodes(Array.isArray(value) ? value : [], "CPTCODE"));
                            }}
                          />
                        </Box>
                      </Box>
                  </Grid>
                )}

                {selectedCPTs && selectedCPTs.length > 0 &&
                  <Grid item xs={12}>
                    <Box>
                      <BorderedSection title={'Description'}>
                        <Grid container spacing={1.5} mt={-3}>
                        {(selectedCPTs || [])
                            .filter((cpt): cpt is { woundKey: any; woundDescription: any } => !!cpt)
                            .map((cpt, index) => (
                              <Grid key={cpt.woundKey ?? index} item md={12} style={{ textAlign: 'justify' }}>
                                {cpt.woundKey}{" - "}{cpt.woundDescription}
                              </Grid>
                            ))}
                        </Grid>
                      </BorderedSection>
                    </Box>
                  </Grid>
                }

                {woundType === "Diabetic Ulcer" && (
                  <>
                    {eCodeDropdown()}
                    {lCodeDropdown()}
                  </>
                )}

                {woundType === "Venous Ulcer" && (
                  <>
                    {iCodeDropdown()}
                    {lCodeDropdown()}

                  </>
                )}

                {(woundType === "Pressure Ulcer" ||
                  woundType === "Chronic Wound") && (
                    <>
                      {lCodeDropdown()}

                    </>
                  )}
                  
               
                <Grid item xs={12}>
                  <Box>
                    <FieldLabel label="Location" required tokens={modalTokens} />
                    <Box sx={dropdownWrapSx(!!errors.procedureLocation)}>
                      <CustomAutocompleteField
                        name="procedureLocation"
                        control={control}
                        label=""
                        size="small"
                        fetchFunction = {fetchWoundCodesByWoundKey}
                        initialFetchFunction = {fetchWoundsByWoundCodes}
                        woundCodeType="ProcedureLocation"
                        transformResponse={transformWoundCodeResponse}
                        rules={{ required: "Location is required." }}
                        initialCodes = {getValues("procedureLocation")}
                        isMultiple = {false}
                      />
                    </Box>
                  </Box>
                  </Grid>
                {!(woundType === "Other" || getValues("woundType") === "" || getValues("woundType") === "Acute Wound" ) && (
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <Typography mr={4} sx={{ fontSize: "0.88rem", color: modalTokens.textPrimary }}>
                      Specify Other DX Codes?
                    </Typography>
                    <CustomCheckbox
                      control={control}
                      label="Yes"
                      controllerName="checkboxSpecifiedDxCodes"
                      checked={specifyOtherDxCodes}
                      onChange={handleCheckboxChange}
                    />
                  </Grid>
                )}

                {((shouldShowDxCodesField) || woundType === "Other" || woundType === "Acute Wound") && (
                  <Grid item xs={12}>
                    <Box>
                      <FieldLabel label="Specify Other Dx Code(s) / ICD-10" required tokens={modalTokens} />
                      <Box sx={inputFieldSx(!!errors.otherDxCodes)}>
                        <CustomTextField
                          controllerName="otherDxCodes"
                          control={control}
                          label=""
                          size="small"
                          rules={{ required: "Other is required." }}
                          multiline
                          rows={4}
                          maxRows={4}
                        />
                      </Box>
                    </Box>
                    <Typography sx={{ fontSize: "0.75rem", color: modalTokens.textSecondary, mt: 0.5 }}>
                      Separate codes with comma (,)
                    </Typography>
                  </Grid>
                )}
                {showSearchPopup && (
                  <IVRWoundSearchPopup
                    open={showSearchPopup}
                    onClose={() => { setShowSearchPopup(false) }}
                    onSubmitData=
                    {(data: any) => {
                      if (data) {
                        const existing = getValues("otherDxCodes") || "";
                        let updated = "";
                        if (existing) {
                          updated = existing.endsWith(",")
                            ? `${existing}${data}`
                            : `${existing},${data}`;
                        } else {
                          updated = data;
                        }
                        setValue("otherDxCodes", updated.toString());
                      }
                    }}
                  />
                )}                
                {/* CS-1187 - End */}
                <Grid item xs={12} sm={4} md={4}>
                  <Box>
                    <FieldLabel label="Length(cm)" required tokens={modalTokens} />
                    <Box sx={inputFieldSx(!!errors.length)}>
                      <CustomNumberField
                        controllerName="length"
                        control={control}
                        label=""
                        size="small"
                        allowDecimal={true}
                        decimalScale={2}
                        allowNegative={false}
                        rules={{ required: "Length is required.",
                            min: { value: 0.01, message: "Length must be greater than 0." } // CS-1605 
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <Box>
                    <FieldLabel label="Width(cm)" required tokens={modalTokens} />
                    <Box sx={inputFieldSx(!!errors.width)}>
                      <CustomNumberField
                        controllerName="width"
                        control={control}
                        label=""
                        size="small"
                        allowDecimal={true}
                        decimalScale={2}
                        allowNegative={false}
                        rules={{ required: "Width is required.",
                          min: { value: 0.01, message: "Width must be greater than 0." } // CS-1605 
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <Box>
                    <FieldLabel label="Depth(cm)" required tokens={modalTokens} />
                    <Box sx={inputFieldSx(!!errors.depth)}>
                      <CustomNumberField
                        controllerName="depth"
                        control={control}
                        label=""
                        size="small"
                        allowDecimal={true}
                        decimalScale={2}
                        allowNegative={false}
                        rules={{ required: "Depth is required." }}
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Box>
                    <FieldLabel label="Estimate Surface Area (LxW)" tokens={modalTokens} />
                    <Box sx={inputFieldSx(false)}>
                      <CustomTextField
                        controllerName="estimateSurfaceArea"
                        control={control}
                        label=""
                        size="small"
                        isDisabled={true}
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Box>
                    <FieldLabel label="Total Wound Volume (LxWxD)" tokens={modalTokens} />
                    <Box sx={inputFieldSx(false)}>
                      <CustomTextField
                        controllerName="totalWoundVolume"
                        control={control}
                        label=""
                        size="small"
                        isDisabled={true}
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Box>
                    <FieldLabel label="Exudate" required={from === CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT} tokens={modalTokens} />
                    <Box sx={dropdownWrapSx(!!errors.exudate)}>
                      <CustomDropdownField
                        name="exudate"
                        control={control}
                        options={exudateListOptions}
                        label=""
                        size="small"
                        onChangeSelect={() => { }}
                        sortOptions={false}
                        rules={ from === CAN_ACCESS_APPLICATION.ORDER_MANAGEMENT ? { required: "exudate is required." } : {}}
                      />
                    </Box>
                  </Box>
                </Grid>
              </Grid>
          </Box>

          <Box sx={footerSx}>
            <Box
              sx={{
                display: "flex",
                gap: 1.5,
                justifyContent: isMobile ? "stretch" : "flex-end",
                flexDirection: isMobile ? "column-reverse" : "row",
                flexWrap: "wrap",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                fullWidth={isMobile}
                startIcon={<SaveAlt sx={{ fontSize: "1rem !important" }} />}
                sx={primaryBtnSx}
              >
                Save
              </Button>
              <Button
                variant="outlined"
                fullWidth={isMobile}
                startIcon={<CancelIcon sx={{ fontSize: "1rem !important" }} />}
                onClick={handleClose}
                sx={cancelBtnSx}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </Dialog>
      <CustomAlert
        open={showErrorAlert}
        onClose={() => setShowErrorAlert(false)}
        severity="info"
        message="Feature currently under development. Stay tuned for updates!"
      />
    </>
  );
};

export default IVRFormWoundInfoPopup;
